import { render, staticRenderFns } from "./AdsType22.vue?vue&type=template&id=4a00e892&scoped=true&lang=html&"
import script from "./AdsType22.vue?vue&type=script&lang=js&"
export * from "./AdsType22.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AdsType22.vue?vue&type=style&index=0&id=4a00e892&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4a00e892",
  null
  ,true
)

export default component.exports